(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-rich-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    // Select the rich text section with the id 'insta-heading'
    const instaHeading = document.getElementById('insta-heading');

    // Check if the section exists
    if (instaHeading) {
        // Find the h2 element inside the section
        const h2Element = instaHeading.querySelector('h2');

        // Check if the h2 element exists
        if (h2Element) {
            // Wrap the h2 content in a link
            const linkElement = document.createElement('a');
            linkElement.href = 'https://www.instagram.com/ardaghglassafrica/?hl=en';
            linkElement.target = '_blank'; // Open link in a new tab
            linkElement.rel = 'noopener noreferrer'; // Security and performance best practices
            linkElement.textContent = h2Element.textContent;

            // Replace the h2 content with the link
            h2Element.textContent = ''; // Clear the original text
            h2Element.appendChild(linkElement);
        }
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login"]) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function () {
    // Select the email input and its associated label
    const emailInput = document.querySelector('input[name="customer[email]"]');
    const emailLabel = document.querySelector('label[for*="customer_email"]'); // Adjust for dynamic IDs

    if (emailInput && emailLabel) {
        // Add event listener for focus to apply the active CSS
        emailInput.addEventListener('focus', function () {
            emailLabel.classList.add("input-active");
        });

        // Add event listener for blur to reset the CSS if the input is empty
        emailInput.addEventListener('blur', function () {
            if (this.value.trim() === "") {
                emailLabel.classList.remove("input-active");
            }
        });

        // Ensure the correct class is applied on page load
        if (emailInput.value.trim() !== "") {
            emailLabel.classList.add("input-active");
        }
    } else {
        console.log("Email input or label not found. Check your selectors.");
    }
});

  document.addEventListener("DOMContentLoaded", function () {
    // Select the email input and its associated label
    const passwordInput = document.querySelector('input[name="customer[password]"]');
    const passwordLabel = document.querySelector('label[for*="customer_password"]'); // Adjust for dynamic IDs

    if (passwordInput && passwordLabel) {
        // Add event listener for focus to apply the active CSS
        passwordInput.addEventListener('focus', function () {
            passwordLabel.classList.add("input-active");
        });

        // Add event listener for blur to reset the CSS if the input is empty
        passwordInput.addEventListener('blur', function () {
            if (this.value.trim() === "") {
                passwordLabel.classList.remove("input-active");
            }
        });

        // Ensure the correct class is applied on page load
        if (passwordInput.value.trim() !== "") {
            passwordLabel.classList.add("input-active");
        }
    } else {
        console.log("Email input or label not found. Check your selectors.");
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxs-newsletter"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function () {
    // Select the email input and its associated label
    const emailInput = document.querySelector('input[name="contact[email]"]');
    const emailLabel = document.querySelector('label[for*="newsletter_email-template"]'); // Adjust for dynamic IDs

    if (emailInput && emailLabel) {
        // Add event listener for focus to apply the active CSS
        emailInput.addEventListener('focus', function () {
            emailLabel.classList.add("input-active");
        });

        // Add event listener for blur to reset the CSS if the input is empty
        emailInput.addEventListener('blur', function () {
            if (this.value.trim() === "") {
                emailLabel.classList.remove("input-active");
            }
        });

        // Ensure the correct class is applied on page load
        if (emailInput.value.trim() !== "") {
            emailLabel.classList.add("input-active");
        }
    } else {
        console.log("Email input or label not found. Check your selectors.");
    }
});


  } catch(e) { console.error(e); }
})();
})();
